
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CerrixSelectComponent } from "@app/incident/components/src/lib/core/cerrix-select/cerrix-select.component";
import { SelectOptionModel } from "@app/incident/components/src/lib/core/models/select-option.model";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/incident/i18n/scope";

@Component({
    selector: "page-number-selector",
    templateUrl: "./page-number-selector.component.html",
    styleUrls: ["./page-number-selector.component.scss"],
    imports: [FormsModule, ReactiveFormsModule, CerrixSelectComponent, TranslatePipe],
    providers: [],
    viewProviders: [provideTranslationScope(scope)],
})
export class PageNumberSelectorComponent implements OnInit {
    @Input() public pageSize: number;
    @Input() public pageSizeOptions: number[] = [];

    @Output() public pageNumberChanged: EventEmitter<number> = new EventEmitter<number>();

    protected selected: string;
    protected options: SelectOptionModel[] = [];

    ngOnInit(): void {
        this.selected = this.pageSize?.toString();
        this.options = this.pageSizeOptions.map((o) => {
            return {
                id: o.toString(),
                name: o.toString(),
            };
        });
    }

    protected onChange(value: string): void {
        this.pageNumberChanged.emit(parseInt(value));
    }
}
